"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _UILightbox = _interopRequireDefault(require("UIComponents/lightbox/UILightbox"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _SelectFolderPopover = _interopRequireDefault(require("./SelectFolderPopover"));

var _ShutterstockTosLinks = _interopRequireDefault(require("./ShutterstockTosLinks"));

var _ShutterstockLicenseAgreement = _interopRequireDefault(require("./ShutterstockLicenseAgreement"));

var Modes = (0, _keyMirror.default)({
  PREVIEW: null,
  LICENSE: null
});

function i18nKey(suffix) {
  return "FileManagerCore.shutterstock." + suffix;
}

function renderImageComponent(imageProps) {
  return _react.default.createElement(_UIImage.default, Object.assign({
    style: {
      width: '100%',
      height: 'calc(100% - 5rem)'
    }
  }, imageProps));
}

var ShutterstockPreviewModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ShutterstockPreviewModal, _Component);

  function ShutterstockPreviewModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ShutterstockPreviewModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShutterstockPreviewModal).call(this, props));
    _this.state = {
      mode: Modes.PREVIEW
    };
    _this.handleAgree = _this.handleAgree.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSaveFile = _this.handleSaveFile.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ShutterstockPreviewModal, [{
    key: "handleSaveFile",
    value: function handleSaveFile() {
      var _this$props = this.props,
          userSettings = _this$props.userSettings,
          onAcquire = _this$props.onAcquire,
          image = _this$props.image;

      if (userSettings.get('signedShutterstock')) {
        onAcquire(image);
        return;
      }

      this.setState({
        mode: Modes.LICENSE
      });
    }
  }, {
    key: "handleAgree",
    value: function handleAgree() {
      var _this$props2 = this.props,
          onAgree = _this$props2.onAgree,
          image = _this$props2.image;
      onAgree(image);
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        mode: Modes.PREVIEW
      });
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          image = _this$props3.image,
          onChangeFolder = _this$props3.onChangeFolder,
          shutterstockFolder = _this$props3.shutterstockFolder,
          onTrackInteraction = _this$props3.onTrackInteraction;
      return _react.default.createElement(_UILightbox.default, {
        imageSrc: image.get('largePreviewUrl'),
        onClose: onClose,
        ImageComponent: renderImageComponent
      }, _react.default.createElement("span", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: i18nKey('saveTo'),
        options: {
          folder: shutterstockFolder ? shutterstockFolder.get('name') : 'Stock images'
        }
      }), _react.default.createElement(_SelectFolderPopover.default, {
        folder: shutterstockFolder,
        onChangeFolder: onChangeFolder,
        onTrackInteraction: onTrackInteraction
      })), _react.default.createElement(_ShutterstockTosLinks.default, {
        use: "on-dark",
        compact: true
      }), _react.default.createElement(_UIButton.default, {
        "data-test-id": "save-shutterstock-image-button",
        use: "primary",
        onClick: this.handleSaveFile
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.actions.acquire"
      })));
    }
  }, {
    key: "renderLicenseAgreement",
    value: function renderLicenseAgreement() {
      var onClose = this.props.onClose;
      return _react.default.createElement(_ShutterstockLicenseAgreement.default, {
        onClose: onClose,
        onAgree: this.handleAgree,
        onCancel: this.handleCancel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var mode = this.state.mode;

      if (mode === Modes.LICENSE) {
        return this.renderLicenseAgreement();
      }

      return this.renderPreview();
    }
  }]);
  return ShutterstockPreviewModal;
}(_react.Component);

exports.default = ShutterstockPreviewModal;
ShutterstockPreviewModal.propTypes = {
  image: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  userSettings: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  shutterstockFolder: _propTypes.default.instanceOf(_immutable.default.Map),
  onAgree: _propTypes.default.func.isRequired,
  onAcquire: _propTypes.default.func.isRequired,
  onChangeFolder: _propTypes.default.func.isRequired,
  onTrackInteraction: _propTypes.default.func,
  onClose: _propTypes.default.func.isRequired
};
module.exports = exports.default;